import wx from "weixin-js-sdk";


function setWxConfig(data,port) {
    wx.config({
        debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature,// 必填，签名
        jsApiList: [port] // 必填，需要使用的JS接口列表
    });
}


/**
 * 支付接口
 * @param data
 * @param prepay_id
 * @param paySign
 */
function chooseWXPay(data, prepay_id, paySign) {
           setWxConfig(data,"chooseWXPay");
            wx.ready(function () {
                wx.chooseWXPay({
                    timestamp: data.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                    nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
                    package: "prepay_id="+prepay_id, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                    signType: 'HMAC-SHA256', // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                    paySign: paySign, // 支付签名
                    success: function (res) {
                        // 支付成功后的回调函数
                        console.log(res);
                        return res;
                    }
                });
            })

            //抛出错误问题
             wx.error(function(res){
              // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                 alert(res);
             });
}

function onBridgeReady(data) {

    WeixinJSBridge.invoke('getBrandWCPayRequest', {
            "appId": data.appId,   //公众号ID，由商户传入
            "timeStamp": data.timestamp,   //时间戳，自1970年以来的秒数
            "nonceStr": data.nonceStr,      //随机串
            "package":  data.prepayId,
            "signType": data.signType,     //微信签名方式：
            "paySign": data.paySign
        },
        function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                //支付成功之后实现跳转
                this.$router.push({path: '/order/personalOrders',query: {active: "0"}});
            }
        });
}


export {chooseWXPay, onBridgeReady}

